import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import {Box, Grid, Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import {userActions} from "../../../_redux/actions";
import {useDispatch, useSelector} from "react-redux";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import Paper from "@material-ui/core/Paper";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Checkbox from "@material-ui/core/Checkbox";
import PropTypes from "prop-types";
import {alertActions} from "../../../_redux/actions";

const UserRoleAssign = (props) => {
    const dispatch = useDispatch()
    const roleList = useSelector((state: any) => state.users.roleList)
    const assignUserRole = useSelector((state: any) => state.users.assignUserRole)
    const [selected, setSelected] = React.useState<number[]>([]);

    React.useEffect( () => {
        // dispatch getUserRoleList action & fetch user roles
        dispatch(userActions.getUserRoleList(props.user.email, (data) => {
            let newSelected: number[] = [];
            if(!!data) {
                // set isSelected user roles & update state
                data.forEach( row => {
                    if(row.isAssigned) newSelected.push(row.id)
                })
            }
            setSelected(newSelected)
        }, (error) => {
                // Display alert onError
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }, [props.user])

    // Handle select all roles checkbox change
    const selectAllRoles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = roleList.data.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    }

    // detect role isSelected
    const isSelected = (role: number):boolean => selected.indexOf(role) !== -1;

    // Handle select role (row) checkbox event
    const selectRole = (event: React.MouseEvent<any>, role: number) => {
        const selectedIndex = selected.indexOf(role);
        let newSelected: number[] = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, role);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    }

    return(
        <div>
            <DialogContent>
                <Typography className="uppercase fontSizePrimary">Please fill the detail below to add a new role to the user.</Typography>
                <Typography className="uppercase fontSizePrimary mtM">
                    <Box color="error.main" fontSize={14}>{assignUserRole.isError ? assignUserRole.error.message: null}</Box>
                </Typography>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" size="small" className={'appTable'} >
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        indeterminate={selected.length > 0 && selected.length < roleList.data.length}
                                        checked={roleList.data.length > 0 && selected.length === roleList.data.length}
                                        onChange={selectAllRoles}
                                        color='primary'
                                        inputProps={{ 'aria-label': 'select all' }}
                                    />
                                </TableCell>
                                <TableCell>Role Name</TableCell>
                                <TableCell>Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {roleList.data.map( (row, index) => {
                                const isItemSelected = isSelected(row.id);
                                const labelId = `role-checkbox-${index}`;
                                return(
                                    <TableRow key={row.id} onClick={(event) => selectRole(event, row.id)}>
                                        <TableCell component="td" padding="checkbox">
                                            <Checkbox
                                                checked={isItemSelected}
                                                inputProps={{ 'aria-labelledby': labelId }}
                                                color='primary'
                                            />
                                        </TableCell>
                                        <TableCell component="td">{row.name}</TableCell>
                                        <TableCell>{row.description}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button variant="contained"  color="secondary"
                        onClick={() => props.assignRoles(selected)}
                >
                    Assign
                </Button>
            </DialogActions>
        </div>
    );
}

UserRoleAssign.propTypes = {
    user: PropTypes.object,
    onClose: PropTypes.func,
    assignRoles: PropTypes.func,
}

export default UserRoleAssign
